import { Route, Redirect } from 'react-router-dom';
import React from 'react';
import PrivateRoute from '../components/PrivateRoute';
import UserLogin from '../components/UserLogin';
import Help from '../components/Help';
import UserLogout from '../components/UserLogout';
import Dashboard from '../components/Dashboard';
import Clone from '../components/Briefing/Clone';
import Briefing from '../components/Briefing';
import SelectSourceBriefing from '../components/Briefing/SelectSourceBriefing';
import FormBriefing from '../components/Briefing/form';
import Thanks from '../components/Briefing/Thanks';
import listBriefings from '../components/Briefing/BriefingsList';
import BriefingsDetails from '../components/Briefing/BriefingsDetails';
import ReportShow from '../containers/customer/ShowReport';
import Briefings from '../components/backoffice/Demands';
import BackofficeBriefingDetails from '../components/backoffice/Demands/Details';
import BriefingsClientsList from '../components/backoffice/Clients';
import ClientEdit from '../components/backoffice/Clients/Edit';
import UserEdit from '../containers/backoffice/UserEdit';
import UsersList from '../containers/backoffice/UsersList';
import UserRegister from '../components/UserRegister';
import BackofficeHome from '../components/backoffice/Home';
import BackofficeListReports from '../containers/backoffice/ListReports';
import BackofficeCampaignPosting from '../containers/backoffice/CampaignPosting';
import TemplateList from '../containers/backoffice/Template/List';
import TemplateCreation from '../containers/backoffice/Template/Creation';
import TemplateEdit from '../containers/backoffice/Template/Edit';
import HomeCampanhas from '../containers/campanhas/HomeCampanhas';
import MyCampaigns from '../components/Campanhas/MyCampaigns';
import MyCampaignsDetails from '../containers/campanhas/MinhasCampanhas/Details';
import WithSites from '../containers/campanhas/Sites';
import CampaignReports from '../containers/campanhas/CampaignReports';
import CampaignReportDetail from '../containers/campanhas/CampaignReports/Detail';
import LeadReports from '../containers/campanhas/LeadReports';
import Logo from '../containers/campanhas/Logo';
import SitesPreview from '../containers/campanhas/SitesPreview';
import SitesTicket from '../containers/campanhas/SitesTicket';
import WebmotorsMedia from '../containers/campanhas/WebmotorsMedia';
import WithoutMedia from '../containers/campanhas/WithoutMedia';
import ExternalMedia from '../components/Midia';
import WMTV from '../components/WMTV';

import utils from '../services/utils';
import { redirectTo, redirectToHome } from '../components/Utils/Redirect3rdParty';

const basePath = utils.basePath();

const routes = [
    /* CUSTOMER */
	<Route key="redirect" path="/" exact component={() => redirectTo(process.env.REACT_APP_COCKPIT_URL)} />,
	<PrivateRoute key="logo" path={`${basePath}/logo`} exact component={Logo} />,
	<PrivateRoute key="site" path="/site" exact component={WithSites} />,
	<PrivateRoute key="site-preview" path="/site/:tier(basico|personalizado|pro)" exact component={SitesPreview} />,
	<PrivateRoute key="site-ticket" path="/site/ticket" exact component={SitesTicket} />,
	<PrivateRoute key="homeCampanhas" path={`${basePath}/campanhas`} component={HomeCampanhas} />,
	<Redirect key="jwt-/" from="/jwt" to="/" exact />,
	<Redirect key="sites-site" from="/sites" to="/site" exact />,
	<Route key="help" path={`${basePath}/ajuda`} exact component={Help} />,
	<PrivateRoute key="dashboard" path={`${basePath}/dashboard`} exact component={Dashboard} />,
	<PrivateRoute key="externalMedia" path={`${basePath}/externalmedia`} exact component={ExternalMedia} />,
	<PrivateRoute key="withoutMedia" path={`${basePath}/withoutmedia`} exact component={WithoutMedia} />,
	<PrivateRoute key="webmotorsMedia" path={`${basePath}/webmotorsmedia`} exact component={WebmotorsMedia} />,
	<PrivateRoute key="mycampaigns" path={`${basePath}/minhascampanhas`} exact component={MyCampaigns} />,
	<PrivateRoute key="clone" path={`${basePath}/briefing/clonar`} exact component={Clone} widthFull />,
	<PrivateRoute key="briefing" path={`${basePath}/briefing`} exact component={Briefing} widthFull />,
	<PrivateRoute key="selectSourceBriefing" path={`${basePath}/briefing/clonar/selecionar`} exact component={SelectSourceBriefing} widthFull />,
	<PrivateRoute key="formBriefing" path={`${basePath}/briefing/:token`} exact component={FormBriefing} widthFull />,
	<PrivateRoute key="thanks" path={`${basePath}/obrigado`} exact component={Thanks} widthFull />,
	<PrivateRoute key="listBriefings" path={`${basePath}/briefings`} exact component={listBriefings} />,
	<PrivateRoute key="formBriefing" path={`${basePath}/briefing/:token/step/:position`} exact component={FormBriefing} widthFull />,
	<PrivateRoute key="briefingsDetails" path={`${basePath}/briefings/:briefingId/detalhes/:etapa`} exact component={BriefingsDetails} />,
	<PrivateRoute key="campaignDetails" path={`${basePath}/minhascampanhas/:campaignId`} exact component={MyCampaignsDetails} />,
	<PrivateRoute key="reports" path={`${basePath}/relatorios`} exact component={CampaignReports} />,
	<PrivateRoute key="reports" path={`${basePath}/relatorios/leads" inactivePro`} exact component={LeadReports} />,
	<PrivateRoute key="reports" path={`${basePath}/relatorios/:preSaleId/:startParam?/:endParam?`} exact component={CampaignReportDetail} />,
	<PrivateRoute key="wmtv" path="/webmotorstv" exact component={WMTV} />,

    /* BACKOFFICE */
	<Route key="userRegister" path={`${basePath}/criar-conta`} exact component={UserRegister} />,
	<Route key="userLogin" path={`${basePath}/login`} exact component={UserLogin} />,
	<Route key="userLogout" path={`${basePath}/logout`} exact component={UserLogout} />,
	<PrivateRoute key="backofficeHome" path={`${basePath}/backoffice`} exact component={BackofficeHome} isBackoffice />,
	<PrivateRoute key="briefings" path={`${basePath}/backoffice/demandas`} exact component={Briefings} isBackoffice />,
	<PrivateRoute key="backofficeBriefingDetails" path={`${basePath}/backoffice/demandas/:briefingId/detalhes/:etapa`} exact component={BackofficeBriefingDetails} isBackoffice />,
	<PrivateRoute key="briefingsClientsList" path={`${basePath}/backoffice/clientes`} exact component={BriefingsClientsList} isBackoffice />,
	<PrivateRoute key="clientEdit" path={`${basePath}/backoffice/cliente/:clientId/editar`} exact component={ClientEdit} isBackoffice />,
	<PrivateRoute key="users" path={`${basePath}/backoffice/usuarios`} exact component={UsersList} isBackoffice />,
	<PrivateRoute key="usersCreate" path={`${basePath}/backoffice/usuarios/cadastro`} exact component={UserRegister} isBackoffice />,
	<PrivateRoute key="usersEdit" path={`${basePath}/backoffice/usuarios/:userId`} exact component={UserEdit} isBackoffice />,
	<PrivateRoute key="BackofficeListReports" path={`${basePath}/backoffice/relatorios`} exact component={BackofficeListReports} isBackoffice />,
	<PrivateRoute key="BackofficeShowReports" path={`${basePath}/backoffice/relatorios/:relatorioId`} exact component={ReportShow} />,
	<PrivateRoute key="BackofficeCampaignPosting" path={`${basePath}/backoffice/demandas/:demandId/publicacao`} exact component={BackofficeCampaignPosting} isBackoffice />,
	<PrivateRoute key="reportListBackoffice" path={`${basePath}/backoffice/relatorios`} exact component={BackofficeListReports} isBackoffice />,
	<PrivateRoute key="reportShowBackoffice" path={`${basePath}/backoffice/relatorios/:relatorioId`} exact component={ReportShow} isBackoffice />,
	<PrivateRoute key="templateList" path={`${basePath}/backoffice/templates`} exact component={TemplateList} isBackoffice />,
	<PrivateRoute key="templateCreation" path={`${basePath}/backoffice/templates/cadastro`} exact component={TemplateCreation} isBackoffice />,
	<PrivateRoute key="templateEdit" path={`${basePath}/backoffice/templates/:relatorioId`} exact component={TemplateEdit} isBackoffice />,
	<Route key="pageNotFound" path="*" component={() => redirectToHome()} />,
];

export default routes;
